import React, { useEffect, useState, useMemo, useRef } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import SearchForm from "./SearchForm";
import useDocumentTitle from '../../hooks/useDocumentTitle'
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-hot-toast';
import { useSearchParams, useLocation, useNavigate, useParams } from "react-router-dom";
import { holidaysearchThemes, clearHolidayData, getavailableDestination } from './HolidaySlice';
import { ChevronLeft, ChevronRight, ChevronDown, Search, MapPin, Filter } from 'lucide-react';
import PackageCard from './PackageCard';
import CurFt from '../../components/CurFt';
import HolidayFilter from './HolidayFilter';
// import {
//     CheckCircle2,
//     Building2,
//     Bike,
//     Car,
//     ArrowRight,
//     IndianRupee,
//     Plane,
//     Tag,
//     Home
// } from "lucide-react";
export default function ThemesSearch() {
    useDocumentTitle('Holiday Search');
    const [searchParams] = useSearchParams();
    const { themes } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const fromCity = searchParams.get("fromCity");
    const departuredate = searchParams.get("checkin_date");
    const [duration, setDuration] = useState([2, 20]);
    const [apiData, setApiData] = useState(null);
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const [SearchId, seSearchId] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [SuggestedThemes, setSuggestedThemes] = useState([]);

    const parseSearchParams = () => {
        const searchParams = new URLSearchParams(location.search);
        return {
            fromCity: decodeURIComponent(searchParams.get('fromCity') || ''),
            city: decodeURIComponent(searchParams.get('cityname') || ''),
            cityCode: decodeURIComponent(searchParams.get('cityCode') || ''),
            countryName: decodeURIComponent(searchParams.get('countryName') || ''),
            departuredate: searchParams.get('checkin_date') || '',
            totalAdults: parseInt(searchParams.get('adults') || '1', 10),
            totalChildren: parseInt(searchParams.get('childs') || '0', 10),

        };
    };

    const SearchHolidayData = async (payload) => {
        try {
            setLoading(true)
            dispatch(clearHolidayData())
            const response = await dispatch(holidaysearchThemes(payload)).unwrap();

            setResults(response.data.data)
            seSearchId(response.data?.SearchId)
            setLoading(false)
            if (!response?.data?.success) {
                setLoading(false)
                toast.error(response?.data?.message, { autoClose: 3000 });
                // navigate(`/hotel`);
            }
        } catch (err) {
            console.error("Hotel search or fetch result failed:", err);
        }
    };
    let postData = {
        customer_id: 0
    }
    const fetchDestination = async () => {
        try {
            const response = await dispatch(
                getavailableDestination({ postData })
            ).unwrap();
            const Resultdata = response.data;

            if (Resultdata.status.success) {
                setSuggestions(Resultdata.FromCityData);
                setSuggestedThemes(Resultdata.ThemeData);
            }
        } catch (error) {
            toast.error('Unbale to load destination', { autoClose: 3000 });
        }
    }
    useEffect(() => {
        const parsedData = parseSearchParams();
        const generatedApiData = generateAPIDataFromParams(parsedData);
        setApiData(generatedApiData);
        SearchHolidayData(generatedApiData)
        fetchDestination()
    }, [location.search]);


    const generateAPIDataFromParams = (parsedData) => {
        return {
            searchData: {
                isApiSearch: true,
                searchQuery: {
                    searchCriteria: {
                        dest_city: parsedData.city || null,
                        dest_city_id: parsedData.cityCode,
                        dest_countryName: parsedData.countryName,
                        adults: 1,
                        children: 0,
                        infant: "0",
                        childwob: "0"
                    },
                    DepartureCriteria: {
                        dep_city: parsedData?.fromCity,
                        dep_city_id: null,
                        dep_countryName: null,
                        checkinDate: parsedData.departuredate,
                        nights: "1"
                    },
                    searchPreferences: {
                        packageThemes: (themes === 'umrah') ? 'Pilgrimage' : themes,
                        hotelStars: "1,2,3,4,5"
                    },
                    currency: {
                        CurrencyRate: "1.000000",
                        CurrencyTitle: "INR",
                        CurrencyId: 1
                    }
                }
            }
        };
    };
    const priceBounds = React.useMemo(() => {
        if (!results?.length) return [0, 0];

        const allPrices = results.flatMap(pkg =>
            pkg.categories?.map(c => Number(c.finalPrice)) || []
        );

        return [
            Math.min(...allPrices),
            Math.max(...allPrices)
        ];
    }, [results]);
    const durationBounds = React.useMemo(() => {
        if (!results?.length) return [1, 20];

        const durations = results.map(r =>
            Number(r.PackageDuration)
        );

        return [
            Math.min(...durations),
            Math.max(...durations)
        ];
    }, [results]);

    const [filters, setFilters] = React.useState({
        priceRange: [0, 0],
        durationRange: [1, 20],
        flightType: "all", // all | with | without
        depCities: [],
        desCities: [],
        hotelStars: [],
        selectedThemes: [],
        selectedInclusions: [],
        sortBy: ""
    });
    React.useEffect(() => {
        setFilters(prev => ({
            ...prev,
            priceRange: priceBounds
        }));
    }, [priceBounds]);
    // const [filteredResults, setFilteredResults] = useState([]);
    const filteredResults = React.useMemo(() => {
        if (!results?.length) return [];

        let data = [...results];

        // PRICE FILTER
        data = data.filter(pkg => {
            const minPrice = Math.min(
                ...(pkg.categories?.map(c => Number(c.finalPrice)) || [0])
            );

            return (
                minPrice >= filters.priceRange[0] &&
                minPrice <= filters.priceRange[1]
            );
        });

        // DURATION FILTER
        data = data.filter(pkg => {
            const nights = Number(pkg.PackageDuration || 0);
            return (
                nights >= filters.durationRange[0] &&
                nights <= filters.durationRange[1]
            );
        });

        // FLIGHT FILTER
        if (filters.flightType !== "all") {
            data = data.filter(pkg => {
                const hasFlight = pkg.inclusion_names
                    ?.toLowerCase()
                    .includes("flight");

                return filters.flightType === "with"
                    ? hasFlight
                    : !hasFlight;
            });
        }

        // DEPARTURE CITY FILTER
        if (filters.depCities.length > 0) {
            data = data.filter(pkg =>
                filters.depCities.includes(pkg.dep_city_name)
            );
        }

        // DESTINATION CITY FILTER
        if (filters.desCities.length > 0) {
            data = data.filter(pkg =>
                filters.desCities.includes(pkg.des_city_name)
            );
        }

        // STAR RATING FILTER
        if (filters.hotelStars.length > 0) {
            data = data.filter(pkg =>
                filters.hotelStars.includes(String(pkg.star))
            );
        }

        // THEME FILTER
        if (filters.selectedThemes.length > 0) {
            data = data.filter(pkg => {
                const themes = pkg.theme_names
                    ?.split(",")
                    .map(t => t.trim());

                return themes?.some(t =>
                    filters.selectedThemes.includes(t)
                );
            });
        }

        // INCLUSION FILTER
        if (filters.selectedInclusions.length > 0) {
            data = data.filter(pkg => {
                const inclusions = pkg.inclusion_names
                    ?.split(",")
                    .map(i => i.trim());

                return filters.selectedInclusions.every(i =>
                    inclusions?.includes(i)
                );
            });
        }

        // SORTING
        data.sort((a, b) => {
            const minA = Math.min(...a.categories.map(c => Number(c.finalPrice)));
            const minB = Math.min(...b.categories.map(c => Number(c.finalPrice)));

            switch (filters.sortBy) {
                case "price_low":
                    return minA - minB;
                case "price_high":
                    return minB - minA;
                case "duration":
                    return Number(a.PackageDuration) - Number(b.PackageDuration);
                default:
                    return 0;
            }
        });

        return data;
    }, [results, filters]);

    const LoadingSkeleton = () => (
        <div className="space-y-4">
            {[...Array(6)].map((_, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md p-4 animate-pulse">
                    <div className="flex">
                        <div className="w-1/4 h-48 bg-gray-300 rounded-lg"></div>
                        <div className="w-3/4 pl-4">
                            <div className="h-6 bg-gray-300 rounded w-3/4 mb-4"></div>
                            <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
                            <div className="h-4 bg-gray-300 rounded w-2/3 mb-4"></div>
                            <div className="flex space-x-2 mb-4">
                                <div className="h-6 bg-gray-300 rounded w-16"></div>
                                <div className="h-6 bg-gray-300 rounded w-16"></div>
                                <div className="h-6 bg-gray-300 rounded w-16"></div>
                            </div>
                            <div className="flex justify-between">
                                <div className="h-8 bg-gray-300 rounded w-32"></div>
                                <div className="h-10 bg-gray-300 rounded w-32"></div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );

    // const [from, setFrom] = useState("");
    const [destinations, setDestination] = useState((themes === 'umrah') ? 'Pilgrimage' : themes);
    // const [sortBy, setSortBy] = useState("none");
    // const [durationFilter, setDurationFilter] = useState("All");
    // const [priceFilter, setPriceFilter] = useState("All");
    // const packages = [
    //     {
    //         id: 1,
    //         title: "Rang Barse in Thailand",
    //         nights: "5N / 6D",
    //         location: "3N Pattaya | 2N Bangkok",
    //         price: 26797,
    //         oldPrice: 40876,
    //         image:
    //             "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
    //         inclusions: ["4* Accommodation", "3+ Activities", "Private Airport Transfers"],
    //         recommended: false,
    //     },
    //     {
    //         id: 2,
    //         title: "Adventures Of Wild Wadi Dubai",
    //         nights: "4N / 5D",
    //         location: "4N Dubai",
    //         price: 43147,
    //         oldPrice: 52231,
    //         image:
    //             "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
    //         inclusions: ["Wild Wadi Water Park", "Marina Dhow Cruise", "4-star accommodation"],
    //         recommended: false,
    //     },
    //     {
    //         id: 2,
    //         title: "Adventures Of Wild Wadi Dubai",
    //         nights: "4N / 5D",
    //         location: "4N Dubai",
    //         price: 43147,
    //         oldPrice: 52231,
    //         image:
    //             "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
    //         inclusions: ["Wild Wadi Water Park", "Marina Dhow Cruise", "4-star accommodation"],
    //         recommended: false,
    //     },
    //     {
    //         id: 2,
    //         title: "Adventures Of Wild Wadi Dubai",
    //         nights: "4N / 5D",
    //         location: "4N Dubai",
    //         price: 43147,
    //         oldPrice: 52231,
    //         image:
    //             "https://images.unsplash.com/photo-1512453979798-5ea266f8880c",
    //         inclusions: ["Wild Wadi Water Park", "Marina Dhow Cruise", "4-star accommodation"],
    //         recommended: false,
    //     },
    // ];



    // const [showPackageType, setShowPackageType] = useState(false);
    // const [selectedPackageTypes, setSelectedPackageTypes] = useState([]);
    // const dropdownRef = useRef(null);
    // useEffect(() => {
    //     function handleClickOutside(event) {
    //         if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    //             setShowPackageType(false);
    //         }
    //     }
    //     document.addEventListener("mousedown", handleClickOutside);
    //     return () => document.removeEventListener("mousedown", handleClickOutside);
    // }, []);
    // const togglePackageType = (type) => {
    //     setSelectedPackageTypes((prev) =>
    //         prev.includes(type)
    //             ? prev.filter((item) => item !== type)
    //             : [...prev, type]
    //     );
    // };

    const [query, setQuery] = useState(fromCity || "");
    const [FromCity, setFromCity] = useState(fromCity || null);
    const currencyRef = useRef(null);

    const [showSuggest, setShowSuggest] = useState(false);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                currencyRef.current &&
                !currencyRef.current.contains(event.target)
            ) {
                setShowSuggest(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const filteredSuggestions = suggestions.filter(item =>
        item.name.toLowerCase().includes(query.toLowerCase())
    );

    const handleCitySelect = (city) => {
        setFromCity(city?.name);
        setShowSuggest(false);
    };
    const SearchSubmit = (e) => {
        e.preventDefault();
        if (!FromCity) {
            toast.error('Please select a from destination');
            return false;
        }
        window.location.href = `/Holidays/${destinations}?fromCity=${FromCity}`;
    };

    return (
        <>
            <div className="bg-gray-100 text-gray-800 relative min-h-screen">
                <main className="max-w-7xl mx-auto ">

                    <div className="bg-[#f6f6f6] min-h-screen">
                        <div
                            className="relative h-[245px] bg-cover bg-center flex items-center justify-center"
                            style={{
                                backgroundImage:
                                    "url('/images/themesbg.png')",
                            }}>
                            <div className="absolute inset-0 bg-black/40" />
                            <div className="relative z-10 text-center w-full px-4">
                                <h1 className="text-4xl font-bold text-white mb-6">
                                    Adventure Tour Packages
                                </h1>
                                {/* SEARCH BAR */}
                                <div className="max-w-4xl mx-auto bg-white rounded-full shadow-lg flex overflow-visible">
                                    {/* FROM */}
                                    <div className="flex items-center px-6 py-2 w-2/3 border-r relative">
                                        <div className="w-9 h-9 flex items-center justify-center bg-gray-100 rounded-full mr-3">
                                            <Search size={16} className="text-gray-500" />
                                        </div>
                                        <div ref={currencyRef} className="w-full "> {/* Added relative here */}
                                            <p className="text-xs text-gray-500 float-left">From</p>
                                            <input
                                                type="text"
                                                value={query}
                                                onChange={(e) => {
                                                    setQuery(e.target.value);
                                                    setShowSuggest(true);
                                                }}
                                                onFocus={() => setShowSuggest(true)}
                                                placeholder="Your From Destination!"
                                                className="w-full outline-none text-gray-700 text-base"
                                            />

                                            {/* Suggestion box - now positioned relative to the input container */}
                                            {showSuggest && (
                                                <div className="absolute left-0 top-full mt-0.5 w-full bg-white rounded-2xl shadow-xl z-[999] animate-in fade-in slide-in-from-top-2">
                                                    {/* Header */}
                                                    <div className="flex items-center gap-3 px-5 py-2 border-b">
                                                        <div className="h-5 w-5 rounded-full border flex items-center justify-center text-gray-500">
                                                            📍
                                                        </div>
                                                        <p className="font-semibold text-md">
                                                            Available <span className="font-normal">From Destinations</span>
                                                        </p>
                                                    </div>

                                                    {/* List */}
                                                    <ul className="max-h-[260px] overflow-auto">
                                                        {filteredSuggestions.length ? (
                                                            filteredSuggestions.map((item, idx) => (
                                                                <li
                                                                    key={idx}
                                                                    onClick={() => {
                                                                        setQuery(item.name);
                                                                        handleCitySelect(item);
                                                                        setShowSuggest(false);
                                                                    }}
                                                                    className="flex items-center gap-4 px-5 py-3 hover:bg-gray-50 rounded-full cursor-pointer"
                                                                >
                                                                    <img
                                                                        src={item.image || '/images/des-placeholder.png'}
                                                                        alt={item.name}
                                                                        className="h-6 w-6 rounded-lg object-cover"
                                                                    />
                                                                    <div className="flex flex-col text-left">
                                                                        <span className="text-md font-medium leading-tight">
                                                                            {item.name}
                                                                        </span>
                                                                    </div>
                                                                </li>
                                                            ))
                                                        ) : (
                                                            <li className="px-5 py-4 text-gray-500">
                                                                No destinations found
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="flex items-center px-6 py-2 w-1/3 border-r relative">
                                        <div className="w-9 h-9 flex items-center justify-center bg-gray-100 rounded-full mr-3">
                                            <MapPin size={14} className="text-gray-500" />
                                        </div>
                                        <div className="w-full">
                                            <p className="text-xs text-gray-500 float-left">Themes/Category</p>
                                            <select
                                                value={destinations}
                                                onChange={(e) => setDestination(e.target.value)}
                                                className="appearance-none p-2 bg-transparent font-medium text-sm w-full outline-none"
                                            >
                                                {SuggestedThemes.length && SuggestedThemes.map((item, idx) => (
                                                    <option>{item.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <ChevronDown size={16} className="absolute right-6 text-gray-500" />
                                    </div>
                                    <button type='button' onClick={SearchSubmit} className="bg-blue-500 w-1/3 rounded-r-full hover:bg-blue-600 text-white px-10 font-semibold">
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* <div className="max-w-7xl mx-auto px-4 py-4 text-sm text-gray-500 flex items-center gap-2">
                            <Home size={14} />
                            Home
                            <span>›</span>
                            Holidays
                            <span>›</span>
                            <span className="text-black font-medium">Adventure</span>
                        </div> */}

                        {/* <div className="max-w-7xl mx-auto px-4 mb-6 flex flex-wrap gap-3 items-center">
                            <div className="relative" ref={dropdownRef}>
                                <button
                                    onClick={() => setShowPackageType(!showPackageType)}
                                    className="flex items-center gap-2 bg-white px-4 py-2 rounded-full shadow text-sm"
                                >
                                    Package Type
                                    <ChevronDown size={14} />
                                </button>

                                {showPackageType && (
                                    <div className="absolute mt-3 w-72 bg-white rounded-2xl shadow-xl p-6 z-50">

                                        <h3 className="text-lg font-semibold mb-4">
                                            Package Type
                                        </h3>

                                        <div className="space-y-4">

                                            {[
                                                "Customizable Packages",
                                                "Group Departure",
                                                "Book Now",
                                            ].map((type) => (
                                                <label
                                                    key={type}
                                                    className="flex items-center gap-3 cursor-pointer"
                                                >
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedPackageTypes.includes(type)}
                                                        onChange={() => togglePackageType(type)}
                                                        className="w-5 h-5 rounded border-gray-300"
                                                    />
                                                    <span className="text-gray-800 text-base">
                                                        {type}
                                                    </span>
                                                </label>
                                            ))}

                                        </div>
                                    </div>
                                )}
                            </div>

                            <button className="ml-auto text-red-500 text-sm font-medium">
                                Reset All
                            </button>
                        </div>
                        <div className="max-w-7xl mx-auto px-4 pb-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6">

                            {packages.map((pkg) => (
                                <div
                                    key={pkg.id}
                                    className="bg-white rounded-2xl shadow hover:shadow-lg transition overflow-hidden"
                                >
                                    <div className="relative">
                                        <img
                                            src={pkg.image}
                                            alt={pkg.title}
                                            className="h-52 w-full object-cover"
                                        />

                                        <span className="absolute top-3 left-3 bg-blue-600 text-white text-xs px-3 py-1 rounded-full">
                                            {pkg.nights}
                                        </span>

                                        <span className="absolute top-3 right-3 bg-indigo-600 text-white text-xs px-3 py-1 rounded-md">
                                            Add to Compare
                                        </span>
                                    </div>

                                    <div className="p-5">

                                        <h3 className="font-semibold text-lg">{pkg.title}</h3>
                                        <p className="text-sm text-gray-500 mb-3">{pkg.location}</p>

                                        <div className="flex items-center gap-4 text-gray-600 mb-3">
                                            <Building2 size={18} />
                                            <Bike size={18} />
                                            <Car size={18} />
                                            <Utensils size={18} />
                                        </div>

                                        <ul className="grid grid-cols-2 gap-x-4 gap-y-1 mb-4">
                                            {pkg.inclusions.map((feature, idx) => (
                                                <li
                                                    key={idx}
                                                    className="flex items-start gap-2 text-[11px] text-gray-700"
                                                >
                                                    <CheckCircle2
                                                        size={12}
                                                        className="text-green-500 mt-0.5 shrink-0"
                                                    />
                                                    <span>{feature}</span>
                                                </li>
                                            ))}
                                        </ul>
                                        <div className="flex justify-between items-end grid-cols-2 border-t pt-3">
                                            <div>

                                                <div>
                                                    <p className="text-[10px] text-gray-400">Starting From</p>
                                                    <p className="text-xs text-gray-400 line-through">₹ {pkg.oldPrice.toLocaleString()}</p>
                                                    <p className="text-xl font-bold text-gray-900">₹ {pkg.price.toLocaleString()}</p>
                                                    <p className="text-[10px] text-gray-500 italic">Per Person on twin sharing</p>
                                                </div>
                                            </div>
                                            <div>
                                                <button className="mt-3 bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-full flex items-center gap-2 text-sm">
                                                    View Details <ArrowRight size={14} />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div> */}


                        <div className="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row gap-6 pb-12 mt-4">

                            <div className="w-full lg:w-1/4">
                                <HolidayFilter
                                    results={results}
                                    filters={filters}
                                    setFilters={setFilters}
                                    priceBounds={priceBounds}
                                    durationBounds={durationBounds}
                                    filteredResults={filteredResults}
                                />
                                {/* <div className="w-80 bg-white rounded-2xl shadow-sm p-6 sticky top-4 h-fit">
                                    <div className="flex justify-between items-center mb-6">
                                        <h2 className="text-lg font-semibold">Filters</h2>
                                        <button
                                            onClick={() => setFilters({
                                                priceRange: priceBounds,
                                                durationRange: [1, 20],
                                                flightType: "all",
                                                depCities: [],
                                                desCities: [],
                                                hotelStars: [],
                                                selectedThemes: [],
                                                selectedInclusions: [],
                                                sortBy: ""
                                            })}
                                            className="text-sm text-blue-600"
                                        >
                                            Clear All
                                        </button>
                                    </div>

                                    <FilterSection title="Price Range">
                                        <div className="relative h-2 mb-6">
                                            <div className="absolute w-full h-2 bg-gray-200 rounded-full"></div>

                                            <div
                                                className="absolute h-2 bg-blue-500 rounded-full"
                                                style={{
                                                    left: `${((minPrice - min) / (max - min)) * 100}%`,
                                                    right: `${100 - ((maxPrice - min) / (max - min)) * 100}%`
                                                }}
                                            ></div>

                                            <input
                                                type="range"
                                                min={min}
                                                max={max}
                                                value={minPrice}
                                                onChange={handleMinChange}
                                                className="absolute w-full h-2 appearance-none bg-transparent pointer-events-none [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-blue-600 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:pointer-events-auto [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-white [&::-webkit-slider-thumb]:shadow-md"
                                            />

                                            <input
                                                type="range"
                                                min={min}
                                                max={max}
                                                value={maxPrice}
                                                onChange={handleMaxChange}
                                                className="absolute w-full h-2 appearance-none bg-transparent pointer-events-none [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:h-5 [&::-webkit-slider-thumb]:w-5 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-blue-600 [&::-webkit-slider-thumb]:cursor-pointer [&::-webkit-slider-thumb]:pointer-events-auto [&::-webkit-slider-thumb]:border-2 [&::-webkit-slider-thumb]:border-white [&::-webkit-slider-thumb]:shadow-md"
                                            />
                                        </div>

                                        <div className="flex justify-between items-center">
                                            <div className="text-center">
                                                <div className="text-sm font-bold text-gray-700">
                                                    <CurFt currency={filteredResults[0]?.currency?.name || 'INR'} price={parseFloat(minPrice)} />
                                                </div>
                                            </div>
                                            <div className="text-center">
                                                <div className="text-sm font-bold text-gray-700">
                                                    <CurFt currency={filteredResults[0]?.currency?.name || 'INR'} price={parseFloat(maxPrice)} />
                                                </div>
                                            </div>
                                        </div>

                                    </FilterSection>
                                    <FilterSection title="Duration (Nights)">

                                        <input
                                            type="range"
                                            min={durationBounds[0]}
                                            max={durationBounds[1]}
                                            value={filters.durationRange[1]}
                                            onChange={(e) =>
                                                setFilters({
                                                    ...filters,
                                                    durationRange: [
                                                        durationBounds[0],
                                                        Number(e.target.value)
                                                    ]
                                                })
                                            }
                                            className="w-full price-slider"
                                        />

                                        <div className="flex justify-between text-sm font-medium mt-2">
                                            <span>{durationBounds[0]}N</span>
                                            <span>{filters.durationRange[1]}N</span>
                                        </div>

                                    </FilterSection>
                                    <FilterSection title="Flight">
                                        <div className="flex gap-2">
                                            {["all", "with", "without"].map(type => (
                                                <button
                                                    key={type}
                                                    onClick={() =>
                                                        setFilters({ ...filters, flightType: type })
                                                    }
                                                    className={`px-3 py-1 rounded-full text-sm border ${filters.flightType === type
                                                        ? "bg-blue-600 text-white"
                                                        : "bg-gray-100"
                                                        }`}
                                                >
                                                    {type === "all"
                                                        ? "All"
                                                        : type === "with"
                                                            ? "With Flight"
                                                            : "Without Flight"}
                                                </button>
                                            ))}
                                        </div>
                                    </FilterSection>

                                    <FilterSection title="Departure City">

                                        {destinationCities.map(city => (
                                            <label key={city} className="flex gap-2 mb-2">
                                                <input
                                                    type="checkbox"
                                                    checked={filters.depCities.includes(city)}
                                                    onChange={() => {
                                                        const updated = filters.depCities.includes(city)
                                                            ? filters.depCities.filter(c => c !== city)
                                                            : [...filters.depCities, city];

                                                        setFilters({ ...filters, depCities: updated });
                                                    }}
                                                />
                                                {city}
                                            </label>
                                        ))}

                                    </FilterSection>

                                    <FilterSection title="Themes">

                                        {themeOptions.map(theme => (
                                            <label key={theme} className="flex gap-2 mb-2">
                                                <input
                                                    type="checkbox"
                                                    checked={filters.selectedThemes.includes(theme)}
                                                    onChange={() => {
                                                        const updated =
                                                            filters.selectedThemes.includes(theme)
                                                                ? filters.selectedThemes.filter(t => t !== theme)
                                                                : [...filters.selectedThemes, theme];

                                                        setFilters({
                                                            ...filters,
                                                            selectedThemes: updated
                                                        });
                                                    }}
                                                />
                                                {theme}
                                            </label>
                                        ))}

                                    </FilterSection>

                                    <FilterSection title="Inclusions">

                                        {inclusionOptions.map(item => (
                                            <label key={item} className="flex gap-2 mb-2">
                                                <input
                                                    type="checkbox"
                                                    checked={filters.selectedInclusions.includes(item)}
                                                    onChange={() => {
                                                        const updated =
                                                            filters.selectedInclusions.includes(item)
                                                                ? filters.selectedInclusions.filter(i => i !== item)
                                                                : [...filters.selectedInclusions, item];

                                                        setFilters({
                                                            ...filters,
                                                            selectedInclusions: updated
                                                        });
                                                    }}
                                                />
                                                {item}
                                            </label>
                                        ))}

                                    </FilterSection>
                                    <FilterSection title="Star Rating">
                                        {[5, 4, 3, 2, 1].map(star => (
                                            <label key={star} className="flex items-center gap-2 mb-2">
                                                <input
                                                    type="checkbox"
                                                    checked={filters.hotelStars.includes(String(star))}
                                                    onChange={() => {
                                                        const updated = filters.hotelStars.includes(String(star))
                                                            ? filters.hotelStars.filter(s => s !== String(star))
                                                            : [...filters.hotelStars, String(star)];

                                                        setFilters({ ...filters, hotelStars: updated });
                                                    }}
                                                />
                                                <span>{star} Star</span>
                                            </label>
                                        ))}
                                    </FilterSection>

                                </div> */}
                            </div>

                            <div className="w-full lg:w-3/4">

                                <div className="bg-white rounded-lg shadow-sm mb-4 flex overflow-hidden text-sm">
                                    {/* <button className="flex-1 py-3 px-4 bg-blue-50 text-blue-600 font-bold border-b-2 border-blue-500 flex items-center justify-center gap-1">
                                        Sort by <ChevronDown size={14} />
                                    </button>
                                    <button className="flex-1 py-3 px-4 hover:bg-gray-50 text-gray-600 font-medium">Duration</button>
                                    <button className="flex-1 py-3 px-4 hover:bg-gray-50 text-gray-600 font-medium flex items-center justify-center gap-1">
                                        Price <span className="text-xs text-blue-500">↓</span>
                                    </button> */}
                                    <button
                                        className="flex-1 py-3 px-4 hover:bg-gray-50 text-gray-600 font-medium"
                                        onClick={() => setFilters(p => ({ ...p, sortBy: 'duration' }))}
                                    >
                                        Duration
                                    </button>

                                    <button
                                        className="flex-1 py-3 px-4 hover:bg-gray-50 text-gray-600 font-medium flex items-center justify-center gap-1"
                                        onClick={() => setFilters(p => ({ ...p, sortBy: 'price_low' }))}
                                    >
                                        Price ↑
                                    </button>

                                    <button
                                        className="flex-1 py-3 px-4 hover:bg-gray-50 text-gray-600 font-medium flex items-center justify-center gap-1"
                                        onClick={() => setFilters(p => ({ ...p, sortBy: 'price_high' }))}
                                    >
                                        Price ↓
                                    </button>
                                </div>
                                {loading ? (
                                    <LoadingSkeleton />
                                ) : (
                                    <>
                                        {/* <div className="text-right text-xs text-gray-500 mb-4">Showing 10 Trips</div> */}

                                        <div className="space-y-6">
                                            {filteredResults.length > 0 ? (
                                                <>
                                                    {filteredResults && filteredResults.map((pkg) => (
                                                        <PackageCard key={pkg.id} pkg={pkg} SearchId={SearchId} />
                                                    ))}
                                                </>
                                            ) : (
                                                <>
                                                    <div className="text-center text-xl text-gray-500 mb-4">No package found</div>
                                                </>
                                            )}

                                        </div>
                                    </>
                                )}

                            </div>
                        </div>
                    </div>

                </main>
            </div>
        </>
    );
}
